<template>
  <div class="environment-select">
    <a-select
      :value="value"
      :disabled="disabled"
      allow-clear
      show-search
      option-filter-prop="search"
      option-label-prop="label"
      placeholder="Не выбрано"
      style="width: 100%"
      @change="$emit('update:value', $event)">
      <a-select-option
        v-for="environment in environments"
        :key="environment.id"
        :value="environment.id"
        :label="getEnvironmentDisplayName(environment)"
        :search="getEnvironmentDisplayName(environment)">
        <span class="environment-option">
          <environment-preview
            v-if="environment.preview_url"
            :src="environment.preview_url"
            :name="getEnvironmentDisplayName(environment)" />
          <span class="option-details">
            <span>{{ environment.name }}</span>
            <a-tag v-if="environment.alt_name">{{ environment.alt_name }}</a-tag>
          </span>
        </span>
      </a-select-option>
    </a-select>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { getEnvironmentDisplayName } from '@/helpers/environmentDisplayName';
import EnvironmentPreview from './EnvironmentPreview.vue';

defineProps({
  value: { type: Number, default: null },
  disabled: { type: Boolean, default: false },
});
defineEmits(['update:value']);
const store = useStore();
onMounted(() => store.dispatch('substances/getUnrealEnvironment'));
const environments = computed(() => store.state.substances.unrealEnvironment
  .filter((environment) => environment.name?.trim() && !environment.deleted_at));
</script>

<style scoped>
.environment-select { width: 100%; min-width: 0; }
.environment-option { display: flex; align-items: center; gap: 8px; white-space: normal; }
.environment-option :deep(.thumbnail) { flex-shrink: 0; }
.option-details { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; min-width: 0; }
.option-details > span { overflow-wrap: anywhere; }
.option-details .ant-tag { margin: 0; }
</style>
